import sliceCreator from '../../index.js';
import {CREATE_RAW_MATERIAL} from '../../../constants/index.js';
const _createRawMaterialsAction = sliceCreator('CREATE_RAW_MATERIAL', CREATE_RAW_MATERIAL, 'post');

const { asyncAction: createRawMaterialsAction, reducer, clearData: clearCreateRawMaterialsAction } = _createRawMaterialsAction;

export default reducer;

export {
    createRawMaterialsAction,
    clearCreateRawMaterialsAction
}